export const removeEmTags = (str: string): string => (str ? str.replace(/<em>/g, '').replace(/<\/em>/g, '') : '');

export function wait(time: number): Promise<void> {
  return new Promise((resolve) => {
    const timeout = window.setTimeout(() => {
      resolve();
      window.clearTimeout(timeout);
    }, time);
  });
}

export function getLocale(country: string, language: string): string | never {
  return language && country ? `${language.toLowerCase()}_${country.toUpperCase()}` : 'en_GB';
}
